"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformTextComponentParameters = void 0;
exports.PlatformTextComponentParameters = [
    {
        id: 'text',
        label: 'Text',
        description: 'Input Param - Text',
        type: 'string',
        paramType: 'STRING',
        required: true,
        stripHtml: false,
    },
    {
        id: 'type',
        label: 'Flow Type',
        description: 'Input Param - Determines how the flow proceeds to the next component',
        type: 'enum',
        paramType: 'ENUM',
        list: {
            AUTO: 'Move to the next component automatically',
            DELAY: 'Wait for a specified delay',
            MANUAL: 'User clicks a button to proceed',
        },
        required: false,
    },
    {
        id: 'delay',
        label: 'Delay',
        description: 'Input Param - Delay in milliseconds before moving to the next component',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'enable_fullscreen',
        label: 'Open In Fullscreen',
        description: 'Input Param - Whether the text should be opened in fullscreen. Useful for long texts',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'collapsable',
        label: 'Collapsable',
        description: 'Input Param - Whether the text is collapsable',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'max_lines',
        label: 'Max Lines',
        description: 'Input Param - Maximum number of lines to show in the text before collapsing',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
];
//# sourceMappingURL=PlatformTextComponent.js.map